import React, { useState, useEffect, useCallback } from "react";
import List from "../../../../styledComponents/Table/List";
import menuIcon from "../../../../../assets/images/DeathModuleNew/Menu.png";
import plaidIcon from "../../../../../assets/images/budget/plaidlogo.png";
import { Icon } from "antd";
import { InputNumber } from "antd";
import moment from "moment";
import Tab, { TabItem } from "../../Recurring/RecurringTabs/Tabs";
import { Table } from "antd";
import { debounce } from "lodash";
import { MODULE_API } from "../../../../../apis";
import NewLoader from "../../../../../components/styled-components/loader/NewLoader";
import swal from "sweetalert";
import BUDGET_API from "../../../../../apis/budget.api";

export const CashTab = (props) => {
  const [dropdown, setDropdown] = useState(false);
  const [selectedItemId, setSelectedItemId] = useState();
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [selectedTab, setSelectedTab] = useState(null);
  const [selectedData, setSelectedData] = useState(null);
  const [formData, setFormData] = useState(null);
  const [editCashHoldindg, setEditCashHoldindg] = useState(false);
  const [loading, setLoading] = useState(false);
  const [searchTransactions, setSearchTransactions] = useState(null);
  const [prevAmount, setPrevAmount] = useState(0);

  const onTabSelected = (index) => {
    const selectedTabName = getTabNameByIndex(index);
    setSelectedTab(selectedTabName);
    setSelectedIndex(index);
  };
  // const totalAmount =
  // props.transactions &&
  // props.transactions.cashData &&
  // props.transactions.cashData.reduce((total, item) => {
  //   return total + item.amount;
  // }, 0);
  // const totalAmount =
  //   props.transactions &&
  //   props.transactions.cashData &&
  //   props.transactions.cashData.reduce((total, item) => {
  //     console.log("item.accountName", item.accountName);
  //     if (selectedTab && selectedTab === "All") {
  //       // Sum amounts for all items
  //       return total + item.amount;
  //     } else if (selectedTab && selectedTab === item.accountName) {
  //       // Sum amounts only for items with the matching account name
  //       return total + item.amount;
  //     } else {
  //       // Skip items that do not match the selected tab
  //       return total;
  //     }
  //   }, 0);
  const totalAmount =
    props.transactions &&
    props.transactions.cashData &&
    props.transactions.cashData.reduce((total, item) => {
      const itemDate = new Date(item.updatedAt);
      const updatedAtDate =
        formData && formData.Amount_updatedAt ? new Date(formData.Amount_updatedAt) : null;

      // Filter by date if updatedAt is provided
      if (updatedAtDate && itemDate < updatedAtDate) {
        return total;
      }

      // Filter by tab
      if (
        selectedTab &&
        selectedTab !== "All" &&
        selectedTab !== item.accountName
      ) {
        return total;
      }

      return total + item.amount;
    }, 0);
  const getTabNameByIndex = (index) => {
    if (index >= 0 && index < filteredTabs.length) {
      return filteredTabs[index];
    } else {
      return null;
    }
  };
  const updateBanksData = (banksData) => {
    const new_banksData = [];
    if (banksData) {
      for (const data of banksData) {
        if (data.accountName) {
          // Check if bankName exists
          new_banksData.push({
            ...data,
            // tabName: data.bankName + " " + data.accountType,
            tabName: data.accountName,
          });
        } else {
          new_banksData.push(data);
        }
      }
      return new_banksData;
    }
  };

  // const updatedBanksData = updateBanksData(
  //   props.transactions &&
  //     props.transactions.cashData &&
  //     props.transactions.cashData
  // );

  const updatedBanksData = updateBanksData(
    props.filterData
      ? props.filterData
      : props.transactions && props.transactions.cashData
      ? props.transactions.cashData
      : []
  );

  const filteredTabs = [
    "All",
    ...new Set(
      updatedBanksData && updatedBanksData.map((item) => item.tabName)
    ),
  ];
  const filterDataByTab = () => {
    if (updatedBanksData && selectedTab) {
      let data;
      if (selectedTab === "All") {
        data = updatedBanksData;
      } else {
        data = updatedBanksData.filter((item) => item.tabName === selectedTab);
      }
      setSelectedData(data);
    }
  };
  // Debounced function for API call
  const handleSearch = useCallback(
    debounce(async (query) => {
      console.log("Search Query before filtering Transaction:", query);

      if (!query) {
        // await getTransactions();
        // setUpdateState((prev) => !prev);
        return;
      }

      setLoading(true);
      try {
        let queryParam = `search=${query}&page=1`;
        let initialResponse = await BUDGET_API.fetchFilterTransaction(
          queryParam
        );

        if (
          !initialResponse ||
          initialResponse.status !== 200 ||
          !initialResponse.data
        ) {
          swal("Error", "Failed to fetch data", "error");
          return;
        }

        const totalPages = initialResponse.data.totalPages;
        let allTransactions = initialResponse.data.transactions || [];

        // Prepare API requests for remaining pages
        const pageRequests = [];
        for (let page = 2; page <= totalPages; page++) {
          let paginatedQueryParam = `search=${query}&page=${page}`;
          pageRequests.push(
            BUDGET_API.fetchFilterTransaction(paginatedQueryParam)
          );
        }

        try {
          // Fetch all pages in parallel
          const responses = await Promise.all(pageRequests);

          // Combine results
          responses.forEach((response) => {
            if (
              response &&
              response.status === 200 &&
              response.data.transactions
            ) {
              allTransactions = allTransactions.concat(
                response.data.transactions
              );
            }
          });

          // Process data into categories
          const allAccount = allTransactions;

          const checkingSavingData = allAccount.filter(
            (item) =>
              (item.accountType === "checking" ||
                item.accountType === "savings") &&
              item.categoryFromPlaid !== null
          );

          const creditData = allAccount.filter(
            (item) =>
              item.accountType === "credit card" &&
              item.categoryFromPlaid !== null
          );

          const investmentData = allAccount.filter(
            (item) =>
              ![
                "checking",
                "savings",
                "credit card",
                "student",
                "loan",
                "auto",
                "business",
                "commercial",
                "construction",
                "consumer",
                "overdraft",
                "home equity",
                "line of credit",
                "mortgage",
              ].includes(item.accountType) && item.categoryFromPlaid !== null
          );

          const studentData = allAccount.filter(
            (item) =>
              [
                "student",
                "mortgage",
                "loan",
                "auto",
                "business",
                "commercial",
                "construction",
                "consumer",
                "overdraft",
                "home equity",
                "line of credit",
              ].includes(item.accountType) && item.categoryFromPlaid !== null
          );

          const cashData = allAccount.filter(
            (item) =>
              item.paidUsing === "Cash" && item.categoryFromPlaid !== null
          );

          const nullCategoryDataNullCategory = allAccount.filter(
            (item) => item.categoryFromPlaid === null
          );

          const resultObject = {
            allAccount,
            checkingSavingData,
            creditData,
            investmentData,
            studentData,
            nullCategoryDataNullCategory,
            cashData,
          };
          setSelectedData(cashData);

          console.log("Final Search Result Object:", resultObject);
          setSearchTransactions(resultObject);
        } catch (error) {
          console.error("Error fetching all pages:", error);
          swal("Error", "Failed to fetch search transactions", "error");
        }
      } catch (error) {
        console.log(error);
      }
      setLoading(false);
    }, 500), // Debounce: 500ms delay
    []
  );
  useEffect(() => {
    if (props.filterData && props.searchQuery) {
      if (props.searchQuery !== "") {
        handleSearch(props.searchQuery);
      } else {
        setSearchTransactions(null);
        setSelectedData(props.filterData);
      }
    } else if (selectedTab && selectedTab !== "All") {
      filterDataByTab();
    } else if (props.transactions && props.transactions.cashData) {
      setSelectedData(props.transactions.cashData);
    } else {
      setSelectedData([]);
    }
  }, [
    selectedTab,
    props.state,
    props.filterData,
    props.searchQuery,
    props.transactions,
  ]);
  const userRole = localStorage.getItem('role') &&  JSON.parse(localStorage.getItem('role')) !== "Financial Advisor Client";
  const cols = [
    {
      title: "Date",
      dataIndex: "date",
      // sorter: (a, b) => a["date"] > b["date"],
      sorter: (a, b) => (a.date || "").localeCompare(b.date || ""),
      // render: (record) =>
      //   record ? moment.utc(record).format("MM-DD-YYYY") : "N/A",
      render: (fileName, record) => {
        return record.pending ? (
          <div
            style={{
              background: "#09A84D",
              padding: "4px",
              color: "white",
              display: "flex",
              justifyContent: "center",
              borderRadius: "4px",
              fontWeight: "bold",
            }}
          >
            Pending
          </div>
        ) : record.date ? (
          moment.utc(record.date).format("MM-DD-YYYY")
        ) : (
          "N/A"
        );
      },
    },
    {
      title: "Item",
      dataIndex: "itemName",
      // sorter: (a, b) => a["itemName"] > b["itemName"],
      sorter: (a, b) => (a.itemName || "").localeCompare(b.itemName || ""),
      render: (fileName, record) => {
        return record.itemName ? (
          <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
            <img
              style={{ borderRadius: "50%" }}
              height={34}
              width={34}
              src={record.itemLogo ? record.itemLogo : plaidIcon}
            ></img>
            <div>{record.itemName}</div>
          </div>
        ) : (
          "N/A"
        );
      },
    },

    {
      title: "Category",
      dataIndex: "categoryFromPlaid",
      // sorter: (a, b) => a["categoryFromPlaid"] > b["categoryFromPlaid"],
      sorter: (a, b) =>
        (a.categoryFromPlaid || "").localeCompare(b.categoryFromPlaid || ""),
      // render: (record) => (record ? record : "N/A"),
      render: (fileName, record) => {
        return record.categoryFromPlaid ? (
          <div
            style={{ cursor: "pointer" }}
            onClick={() => {
              props.handleOpen();
              handleFormDataUpdate(record);
            }}
          >
            <div>{record.categoryFromPlaid}</div>
            {record.subCategory && (
              <span style={{ color: "black" }}>({record.subCategory})</span>
            )}
          </div>
        ) : (
          "N/A"
        );
      },
    },
    {
      title: "Amount",
      dataIndex: "amount",
      sorter: (a, b) => {
        const amountA = parseFloat(a.amount);
        const amountB = parseFloat(b.amount);
        // Toggle sorting order directly
        if (amountA < amountB) {
          return -1; // Sort in ascending order
        } else if (amountA > amountB) {
          return 1; // Sort in descending order
        } else {
          return 0; // Leave items unchanged if they are equal
        }
      },
      render: (fileName, record) => (
        <div
          style={{
            width: "100%",
            fontWeight: "bold",
            color:
              record.typeOfTransaction === "Expense" || record.amount < 0
                ? "black"
                : "#00A27B",
          }}
        >
          {record.amount
            ? !isNaN(record.amount)
              ? `${
                  "$" +
                  (record.typeOfTransaction === "Expense"
                    ? record.amount < 0
                      ? record.amount.toFixed(2) // Keep negative if already negative
                      : (record.amount * -1).toFixed(2) // Otherwise, make negative
                    : record.typeOfTransaction === "Income"
                    ? record.amount > 0
                      ? record.amount.toFixed(2) // Keep positive if already positive
                      : (record.amount * -1).toFixed(2) // Otherwise, make positive
                    : record.amount < 0
                    ? record.amount.toFixed(2) // If amount is negative and no type, show as positive
                    : record.amount.toFixed(2)
                  ) // Positive to negative
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }`
              : "N/A"
            : "N/A"}
        </div>
      ),
    },
    {
      title: "Bank",
      dataIndex: "bankName",
      // sorter: (a, b) => a["bankName"] > b["bankName"],
      sorter: (a, b) => (a.bankName || "").localeCompare(b.bankName || ""),
      render: (fileName, record) => {
        return record.bankName ? (
          <div>
            <div>{record.accountName ? `${record.accountName}` : ""}</div>
            {record.accountType && (
              <span style={{ color: "black" }}>{record.accountType}</span>
            )}
          </div>
        ) : record.paidUsing == "Cash" ? (
          "Cash"
        ) : (
          "N/A"
        );
      },
    },
    {
      title: "Rule Applied",
      dataIndex: "ruleId",
      sorter: (a, b) => (a.ruleId || "").localeCompare(b.ruleId || ""),
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Notes",
      dataIndex: "notes",
      sorter: (a, b) => (a.notes || "").localeCompare(b.notes || ""),
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Action",
      render: (record, index) => {
        return (
          <React.Fragment>
            <div style={{ display: "flex" }} key={index}>
              <div
                onClick={() => {
                  if(userRole){
                  setSelectedItemId(record.id);
                  setDropdown(!dropdown);}
                }}
                style={{
                  cursor: "pointer",
                  marginRight: "1rem",
                  padding: "0px 16px",
                  width: "5px",
                }}
              >
                <img src={menuIcon} alt="menuIcon" height={15} width={4}></img>
              </div>
              {dropdown && selectedItemId === record.id && (
                <React.Fragment>
                  <div
                    onClick={() => {
                      setDropdown(false);
                    }}
                    className=""
                    style={{
                      position: "fixed",
                      width: "100vw",
                      height: "100vh",
                      background: "black",
                      opacity: "0.1",
                      top: "0",
                      left: "0",
                      right: "0",
                      bottom: "0",
                      zIndex: "999",
                    }}
                  ></div>

                  <div class="dropdown" style={{ zIndex: "9999" }}>
                    <ul className="dropdownul">
                      <li
                        className="liHover"
                        onClick={() => {
                          setDropdown(false);
                          props.handleHistoryOpen(record.id);
                        }}
                      >
                        History
                      </li>
                      <li
                        className="liHover"
                        style={{
                          opacity: record.ruleId !== null ? "0.3" : "1",
                          cursor:
                            record.ruleId !== null ? "not-allowed" : "pointer",
                          pointerEvents: record.ruleId !== null ? "none" : "",
                        }}
                        onClick={() => {
                          setDropdown(false);
                          props.handleOpen();
                          handleFormDataUpdate(record);
                        }}
                      >
                        Update
                      </li>

                      <li
                        className="liHover"
                        onClick={() => {
                          setDropdown(false);
                          props.deleteTransaction(record.id);
                        }}
                      >
                        Delete
                      </li>
                    </ul>
                  </div>
                </React.Fragment>
              )}{" "}
            </div>
          </React.Fragment>
        );
      },
    },
  ];

  const TableData = [
    {
      id: 1,
      date: "January 31, 2024",
      item: "Amazon",
      category: "",
      bank: "Checking",
      amount: "$500",
    },
    {
      id: 2,
      date: "Mar 31, 2024",
      item: "Uber",
      category: "",
      bank: "Saving",
      amount: "$400",
    },
    {
      id: 3,
      date: "April 30, 2024",
      item: "Apple",
      category: "",
      bank: "Investment",
      amount: "$900",
    },
    {
      id: 4,
      date: "December 31, 2024",
      item: "Amazon",
      category: "",
      bank: "Credit Card",
      amount: "$800",
    },
  ];
  const handleFormDataUpdate = (data) => {
    props.handleUpdateFormData(data);
  };
  const handleInputFields = (inputName, value) => {
    setFormData({
      ...formData,
      [inputName]: value,
    });
  };
  const handleSave = async () => {
    setEditCashHoldindg(false);
    if (formData && formData.id) {
      updateRecord();
    } else {
      try {
        setLoading(true);
        await MODULE_API.addAsset("Budget Cash", {
          clientModules: [formData],
        });
        await fetchData("Budget Cash");
        setLoading(false);
      } catch (error) {
        console.log(error);
      } finally {
      }
    }
  };
  const updateRecord = async () => {
    try {
      setLoading(true);
      await MODULE_API.updateClientModule(formData.id, {
        ...formData,
      });
      await fetchData(formData.module);
      setLoading(false);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };
  const fetchData = async (moduleName) => {
    try {
      setLoading(true);
      const res = await MODULE_API.fetchItems({
        moduleName,
        pageNum: 1,
        limit: 10,
        body: {},
      });
      const records = res.records || [];
      console.log("records", records);
      const usedAmount = totalAmount ? totalAmount : 0;
      const updatedRecord = {
        ...records[0], // Assuming records[0] contains your base data
        Amount: records[0].Amount - usedAmount, // Add or update the usedAmount field
      };
      console.log("updatedRecord", updatedRecord, usedAmount);
      setFormData(records[0]);
      setLoading(false);
      return { moduleName, records }; // Return object with moduleName to map later
    } catch (error) {
      console.error(`Error fetching data for ${moduleName}:`, error);
      return { moduleName, records: [] }; // Return empty if failed
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData("Budget Cash");
  }, []);

  return (
    <div>
      {" "}
      {filteredTabs && filteredTabs.length > 0 && (
        <div className="TabSection">
          <Tab onTabSelected={onTabSelected} selectedIndex={selectedIndex}>
            {filteredTabs.map((tab, index) => (
              <TabItem key={index}>{tab}</TabItem>
            ))}
          </Tab>
        </div>
      )}
      <div className="subheading">
        Cash
        {editCashHoldindg ? (
          <div
            className="inputWrapper"
            style={{
              display: "flex",
              width: "30%",
              alignItems: "center",
              marginTop: "8px",
            }}
          >
            <span className="dollarSymbol">$</span>
            <InputNumber
              step={1}
              formatter={(value) =>
                `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
              className="Input"
              placeholder="Cash Holding"
              name="Cash Holding"
              value={formData && formData.Amount}
              id="cashHolding"
              onChange={(value) => {
                handleInputFields("Amount", value);
              }}
            />
            <span
              onClick={() => {
                handleSave();
              }}
            >
              <Icon
                type="save"
                style={{ padding: "5px", fontSize: "22px", cursor: "pointer" }}
              />
              </span>
              <span
              onClick={() => {
                setEditCashHoldindg(false);
                setFormData({
                  ...formData,
                  ["Amount"]: prevAmount,
                });
              }}
            >
              <Icon
              type="cross"
              style={{ padding: "5px", color:"red", fontSize: "22px", cursor: "pointer" }}
            />
            </span>
          </div>
        ) : (
          <span className="subheading_amount">
            {console.log("formDataformData", formData)}
            (${" "}
            {formData && formData.Amount
              ? `${(formData.Amount - (totalAmount ? Math.abs(totalAmount) : 0))
                  .toFixed(2)
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
              : "0"}
            )
            <span
              onClick={() => {
                setEditCashHoldindg(true);
                if(formData && formData.Amount){
                  setPrevAmount(formData.Amount)
                }
              }}
            >
              <Icon
                type="edit"
                style={{ padding: "5px", fontSize: "22px", cursor: "pointer" }}
              />
            </span>
          </span>
        )}
      </div>
      <div className="tableContainer">
        <Table
          rowKey="id"
          rowSelection={{
            type: "checkbox",
            selectedRowKeys: props.selectedRowKeys,
            onChange: (selectedRowKeys, selectedRows) => {
              console.log("selectedRowKeys:", selectedRowKeys);
              console.log("selectedRows:", selectedRows);
              props.selectedRowsDataKeys(selectedRowKeys);
            },
          }}
          pagination={{
            showSizeChanger: true, // Show the page size changer
            pageSizeOptions: ["10", "20", "50", "100"], // Options for page size
            defaultPageSize: 10, // Default page size
          }}
          columns={cols}
          dataSource={
            selectedData && selectedData
              ? selectedData
              : props.transactions
              ? props.transactions.cashData
              : []
          }
        />
        <NewLoader isLoading={loading} />
        {/* <List
          cols={cols}
          rows={
            selectedData && selectedData.length > 0
              ? selectedData
              : props.transactions
              ? props.transactions.cashData
              : []
          }
          // rows={
          //   props.transactions &&
          //   props.transactions.cashData
          // }
        /> */}
      </div>
    </div>
  );
};
